import React, { useState, useContext } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import Locales from 'locales';
import { useAPI } from 'hooks';
import { PermissionsContext } from 'context';
import ConfirmationModal from 'components/shared/ConfirmationModal';
import Page from 'components/shared/Page';
import PlatformUnlocked from './components/PlatformUnlocked';
import PlatformLocked from './components/PlatformLocked';

const AGLOPreferences = () => {
  const { api } = useAPI();
  const queryClient = useQueryClient();
  const { isPlatformLocked, isManualLocked, isRegistrationEnd, isQuotaReached } = useContext(PermissionsContext);
  const [openConfirmationModal, setConfirmationModal] = useState(false);

  const modalTitle = isPlatformLocked
    ? Locales.preferences.settings.modal.title.unlock_platform
    : Locales.preferences.settings.modal.title.lock_platform;

  const modalContent = isPlatformLocked
    ? Locales.preferences.settings.modal.confirmation_message.unlock_platform
    : Locales.preferences.settings.modal.confirmation_message.lock_platform;

  const { mutate: lockPlatform } = useMutation({
    mutationFn: () => api.post('permission/lock/'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['permission/current/'] });
      toast.success(Locales.preferences.settings.toast.success_lock);
    },
  });

  const { mutate: unlockPlatform } = useMutation({
    mutationFn: () => api.post('permission/unlock/'),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['permission/current/'] });
      toast.success(Locales.preferences.settings.toast.success_unlock);
    },
  });

  const campaignAction = () => (isPlatformLocked ? unlockPlatform() : lockPlatform());

  return (
    <Page title="Verrouillage de la plateforme" removeContentStyles>
      <div className="max-w-5xl w-full mx-auto space-y-6 px-6">
        {isPlatformLocked && (
          <PlatformLocked
            isManualLocked={isManualLocked}
            isRegistrationEnd={isRegistrationEnd}
            isQuotaReached={isQuotaReached}
            handleOpenConfirmationModal={() => setConfirmationModal(true)}
          />
        )}

        {!isPlatformLocked && <PlatformUnlocked handleOpenConfirmationModal={() => setConfirmationModal(true)} />}
      </div>
      <ConfirmationModal
        isOpen={openConfirmationModal}
        setOpenModal={setConfirmationModal}
        title={modalTitle}
        confirmBtnVariant={isPlatformLocked ? 'hajj' : 'destructive'}
        confirmBtnLabel={isPlatformLocked ? Locales.base.button.unlock : Locales.base.button.lock}
        message={<p>{modalContent}</p>}
        onConfirm={() => campaignAction()}
      />
    </Page>
  );
};

export default AGLOPreferences;
